import React from "react"
import { graphql } from "gatsby";
import {extractContentBetweenTags, splitStringBeforeTag} from "../../utils";
import {useI18next} from "gatsby-plugin-react-i18next";
import teamParallaxVideo from "../../media/videos/team_parallax.webm"
import AbstractLandingPage from "../../components/landing-page";
import { getImage } from "gatsby-plugin-image";

const LandingpageTemplate = ({data}) => {
	const {
		testimonials,
		landingpages,
		products
	} = data
	const {
		language
	} = useI18next()
	const landing = landingpages.edges[0].node.frontmatter

	const landingImg = landing?.headerImagePath?.childImageSharp?.gatsbyImageData || null;

	const successStoryCategoriesToShow = landing.successStoryCategories || []; // Default to empty array if not defined

	const productList = products.edges
	const testimonialList = testimonials.edges
	const landingContent = {
		heading: landing.heading,
		subheadline: landing.subheadline,
		btn: {
			text: landing.btn.text,
			href: landing.btn.href,
		},
		description: landing.description,
		customServiceSection: landing.customServiceSection,
		textColor: landing.heroTextColor,
		subheadlineColor: landing.heroSubheadlineColor,
		listColor: landing.heroListColor,
		logoTitleColor: landing.heroLogoTitleColor,
		illustration: landing?.headerIlluPath || null,
		processSteps: landing.processSteps || null,
		processHeading: landing.processHeading || null,
		problems: landing.problems || null,
		faq: landing.faq || null,
	}
	const services = landing.portfolioIds && landing.portfolioIds.length > 0
		? landing.portfolioIds
		.filter(portfolioId => productList.find(product => product.node.frontmatter.id === portfolioId))
		.map(portfolioId => {
		const item = productList.find(product => product.node.frontmatter.id === portfolioId)
		return {
			excerpt: item.node.excerpt,
			img: getImage(item.node.frontmatter.smallImagePath),
			hideReadMore: item.node.frontmatter.hideReadMore,
			title: item.node.frontmatter.title,
			description: item.node.frontmatter.summary,
			btn: {
				text: "read more",
				href: `/${language}${item.node.fields.slug}`
			}
		}
	})
	: []
	const testimonialData = landing.testimonialIds && landing.testimonialIds.length > 0
		? testimonialList.filter(
			(testimonial) => {
				return landing.testimonialIds.includes(testimonial.node.frontmatter.id)
			}
		).map((item) => {
			return {
				img: getImage(item.node.frontmatter.imagePath),
				name: item.node.frontmatter.name,
				company: item.node.frontmatter.company,
				description: extractContentBetweenTags(splitStringBeforeTag(item.node.html, "h2").slice(-1)[0], "p"),
				href: item.node.frontmatter.href
			}
		})
		: []

	return (
		<AbstractLandingPage
			hideNav={landing.hideNav}
			services={services}
			disablePortfolioLink={landing.disablePortfolioLink}
			customServiceSectionContent={landing.customServiceSection}
			successStoryCategoriesToShow={successStoryCategoriesToShow}
			landingImg={landingImg}
			landingContent={landingContent}
			testimonials={testimonialData}
			testimonialIds={landing.testimonialIds}
			video={ landing.videoPosition === "none"
				? undefined
				: teamParallaxVideo }
			certificates={undefined}
			isVideoOnLanding={
				landing.videoPosition === "top" ?? undefined
			}
			defaultBackgroundColor={landing.defaultBackgroundColor}
		/>
	)
}
export default LandingpageTemplate
export const query = graphql`
    query($slug: String!, $language: String!) {
        locales: allLocale(filter: {language: {eq: $language}}) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        landingpages: allMarkdownRemark(
            filter: {
                fields: {
                    slug: { eq: $slug }
                    language: { eq: $language }
				}
                frontmatter: {
                    category: { eq: "landing" }
                    publish: { eq: true }
                }
            }
        ) {
			totalCount
            edges {
                node {
                    id
                    frontmatter {
						title
                        heading
                        subheadline
                        hideNav
                        headerImagePath {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 2000
                                    height: 900
                                    layout: CONSTRAINED
                                )
                            }
                        }
                        headerIlluPath {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 2000
                                    height: 2000
                                    layout: CONSTRAINED
                                )
                            }
                        }
                        disablePortfolioLink
						videoPosition
						portfolioIds
                        testimonialIds
                        heroTextColor
                        heroSubheadlineColor
                        heroListColor
                        heroLogoTitleColor
                        defaultBackgroundColor
                        description {
                            text
                            list
                        }
                        btn {
                            text
                            href
                        }
                        customServiceSection {
                            title
                            description
                            features {
                                title
                                text
                            }
                        }
                        successStoryCategories
						processSteps {
							title
							description
							img {
                                childImageSharp {
                                    gatsbyImageData(
                                        width: 2000
                                        height: 2000
                                        layout: CONSTRAINED
                                    )
                                }
                            }
						}
						processHeading
                        problems {
                            title
                            description
                        }
                        faq {
                            question
                            answer
                        }
                    }
                    fields {
                        slug
                    }
                    excerpt
                }
            }
        }
        products: allMarkdownRemark(
            filter: {
                fields: {
                    language: { eq: $language }
                }
                frontmatter: {
                    category: { eq: "portfolio" }
                }
            }
        ) {
            edges {
                node {
                    id
                    frontmatter {
						id
                        summary
                        title
						hideReadMore
                        smallImagePath {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 200
                                    height: 200
                                    layout: CONSTRAINED
                                )
                            }
                        }
                    }
                    fields {
                        slug
                    }
                    excerpt
                }
            }
        }
        testimonials: allMarkdownRemark(
            filter: {
                fields: {
                    language: { eq: $language }
                }
                frontmatter: {
                    category: {eq: "testimonial"}
                    publish: {eq: true }
                }
            }
        ) {
            edges {
                node {
                    html
                    fields {
                        language
                        slug
                    }
                    frontmatter {
						id
                        name
                        company
                        href
                        imagePath {
                            childImageSharp {
                                gatsbyImageData(
                                    layout: CONSTRAINED
                                )
                            }
                        }
                    }
                }
            }
        }
    }
`;
